export const MAX_OPTION_VALUES_DISPLAY = 5;
export const ALL_BRANCHES_LIST = [
  {
    ID: 1,
    Type: "San Diego",
  },
  {
    ID: 2,
    Type: "Kansas City",
  },
  {
    ID: 3,
    Type: "Phoenix",
  },
  {
    ID: 4,
    Type: "New England",
  },
  // {
  //   ID: 100,
  //   Type: "DIS Global",
  // },
  // {
  //   ID: 101,
  //   Type: "BranchForTestOnly",
  // },
  {
    ID: 105,
    Type: "Baltimore",
  },
  {
    ID: 107,
    Type: "Denver",
  },
  {
    ID: 108,
    Type: "Dallas",
  },
  {
    ID: 109,
    Type: "New Jersey",
  },
  // {
  //   ID: 110,
  //   Type: "AZ 2",
  // },
  // {
  //   ID: 111,
  //   Type: "Home Office",
  // },
  // {
  //   ID: 112,
  //   Type: "DI Services",
  // },
  // {
  //   ID: 113,
  //   Type: "FASTAPP",
  // },
]
  .map(branch => branch.ID)
  .sort();
